// 公共方法
// 12345
// import Vue from 'vue';
// 引入高德地图(方法一有时候会加载慢,报错)
// import AMap from 'AMap';
// 引入高德地图(方法二)
import {AMap} from '../../assets/libs/loadjs';
import axios from 'axios'
// 获取当前日期和时间
// 使用方法：
// 引入js文件：import { getTime } from '../../../assets/js/xjpublic';
// 调用方法：getTime.getFormatDate(2, '2018-12-13T07:47:12.640Z');
// 参数说明：第一个参数为返回类型，第二个参数为时间(没有第二个参数则代表当前时间)
let getTime = {
  getFormatDate (format, dateTime) {
    let now = new Date();
    if (dateTime) {
      now = new Date(dateTime);
    }
    let year = now.getFullYear(); // 得到年份
    let month = now.getMonth(); // 得到月份
    let date = now.getDate(); // 得到日期
    // let day = now.getDay(); // 得到周几
    let hour = now.getHours(); // 得到小时
    let minu = now.getMinutes(); // 得到分钟
    let sec = now.getSeconds(); // 得到秒
    month = month + 1;
    if (month < 10) month = '0' + month;
    if (date < 10) date = '0' + date;
    if (hour < 10) hour = '0' + hour;
    if (minu < 10) minu = '0' + minu;
    if (sec < 10) sec = '0' + sec;
    let time = '';
    if (format === 1) {
      // 精确到天
      time = year + '-' + month + '-' + date;
    } else if (format === 2) {
      // 精确到秒
      time = year + '-' + month + '-' + date + ' ' + hour + ':' + minu + ':' + sec;
    } else if (format === 3) {
      // 精确到月
      time = year + '-' + month;
    } else if (format === 4) {
      // 精确到分
      time = year + '-' + month + '-' + date + ' ' + hour + ':' + minu;
    }
    return time;
  },
  getFormatDateWithTxt (format, dateTime) {
    let now = new Date();
    if (dateTime) {
      now = new Date(dateTime);
    }
    let year = now.getFullYear(); // 得到年份
    let month = now.getMonth(); // 得到月份
    let date = now.getDate(); // 得到日期
    // let day = now.getDay(); // 得到周几
    let hour = now.getHours(); // 得到小时
    let minu = now.getMinutes(); // 得到分钟
    let sec = now.getSeconds(); // 得到秒
    month = month + 1;
    if (month < 10) month = '0' + month;
    if (date < 10) date = '0' + date;
    if (hour < 10) hour = '0' + hour;
    if (minu < 10) minu = '0' + minu;
    if (sec < 10) sec = '0' + sec;
    let time = '';
    if (format === 1) {
      // 精确到天
      time = year + '年' + month + '月' + date + "日";
    } else if (format === 2) {
      // 精确到秒
      time = year + '-' + month + '-' + date + ' ' + hour + ':' + minu + ':' + sec;
    } else if (format === 3) {
      // 精确到月
      time = year + '-' + month;
    } else if (format === 4) {
      // 精确到分
      time = year + '-' + month + '-' + date + ' ' + hour + ':' + minu;
    }
    return time;
  },
  // 日期转换为今天/明天,参数timeType为具体到天(1),秒(2),分(3),参数data为原始日期如"2019-09-18T09:15:38.877Z",
  // 场景:停车报告/照片列表
  getTimeText (timeType, data) {
    // 最后返回的字符串
    let timeText = '';
    // 具体到天的显示字符串
    let str = '';
    // 当天的时间
    let today = this.getFormatDate(1);
    // 昨天的时间
    let yesterday = this.getFormatDate(1, new Date(new Date() - 1000 * 60 * 60 * 24));
    // 列表中的时间
    let showDate = this.getFormatDate(1, data);
    if (today === showDate) {
      str = '今天';
    } else if (yesterday === showDate) {
      str = '昨天';
    } else {
      str = showDate;
    }
    if (timeType === 1) {
      timeText = str;
    } else if (timeType === 3) {
      timeText = str + ' ' + this.getFormatDate(2, data).substring(11,16)
    } else {
      timeText = str + ' ' + this.getFormatDate(2, data).substring(11,19)
    }
    return timeText;
  },
  getPassedTime (before, after) {
    let passedTime = (parseInt(after) || (new Date()).valueOf() - parseInt(before)) / 1000;
    const {day,hour,min} = this.getFormatDateTxt(passedTime)
    let passedTimeText = '';
    if (day > 0) {
      passedTimeText = day + '天';
    }
    if (hour > 0) {
      passedTimeText += hour + '小时';
    }
    if (min > 0) {
      passedTimeText += parseFloat(min) + '分钟';
    }
    return passedTimeText
  },
  getPassedTimeWithTotal(passedTime){
    const {day,hour,min} = this.getFormatDateTxt(passedTime)
    let passedTimeText = '';
    if (day > 0) {
      passedTimeText = day + '天';
    }
    if (hour > 0) {
      passedTimeText += hour + '时';
    }
    if (min > 0) {
      passedTimeText += parseFloat(min) + '分';
    }
    return passedTimeText
  },
  getFormatDateTxt (passedTime){
    const day = Math.floor(passedTime / 60 / 60 / 24);
    passedTime = passedTime % (86400);
    const hour = Math.floor(passedTime / 60 / 60);
    passedTime = passedTime % (3600);
    const min = Math.floor(passedTime / 60);
    passedTime = passedTime % (60);
    const h = Math.floor(passedTime );
    return {day,hour,min,h};
  },
  getPassedTimeWithTxt (before, after) {
    let passedTime = (new Date(after).getTime()-new Date(before).getTime()) / 1000;
    const {day,hour,min,h} = this.getFormatDateTxt(passedTime)
    let passedTimeText = '';
    if (day > 0) {
      passedTimeText = day + '天';
    }
    if (hour > 0) {
      passedTimeText += hour + '小时';
    }
    if (min > 0) {
      passedTimeText += parseFloat(min) + '分';
    }
    if (h > 0) {
      passedTimeText += parseFloat(h) + '秒';
    }
    return passedTimeText;
  }
};

// 格式检查
let formCheck = {
  validateXjEmail (rule, value, callback) {
    let err;
    let regex = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/;
    if (value !== null && value !== '' && !regex.test(value)) {
      err = '请输入正确的邮箱地址';
    }
    callback(err);
  },
  checkPhone (value) {
    let regex = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
    return (value !== null && value !== '' && regex.test(value))
  },
  checkLicense (value) {
    let regex = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z](?:((\d{5}[A-HJK])|([A-HJK][A-HJ-NP-Z0-9][0-9]{4}))|[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳])$/;
    return (value !== null && value !== '' && regex.test(value));
  },
  checkCard (value) {
    let regex = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
    return (value !== null && value !== '' && regex.test(value));
  }
};

// 浏览器判断
let checkBrowser = {
  // 判断是否是微信浏览器
  isWx () {
    // 取得浏览器的userAgent字符串
    // let userAgent = navigator.userAgent;
    let ua = navigator.userAgent.toLowerCase();
    return (/micromessenger/i.test(ua))
  },
  // 判断是否是ios系统
  isIOS () {
    let u = navigator.userAgent;
    // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  }
};

let stringFn = {
  // 移除字符串前后空格
  trim (str) {
    return str.replace(/(^\s*)|(\s*$)/g, '');
  }
};

// 常量转换判断
let transform = {
  // 摄像头类型
  cameraType (type) {
    let cameraTypeText = '';
    if (type === 1) {
      cameraTypeText = '前置摄像头'
    } else if (type === 2) {
      cameraTypeText = '后置摄像头'
    } else if (type === 3) {
      cameraTypeText = '前+后摄像头'
    }if (type === 4) {
      cameraTypeText = '全景摄像头'
    }
    return cameraTypeText
  },
  // 相册类型
  photoType (type) {
    let photoTypeText = '';
    // 9是停车照片
    let photoTypeAll = ['', '直播历史', '云记录仪', '语音照片', '语音视频', '行车碰撞照片', '行车碰撞视频', '实时拍照', '实时视频', '停车照片', '停车视频', '休眠震动报警照片', '休眠震动报警视频', '', 'SOS视频', '行车碰撞照片', '行车碰撞视频', '休眠震动报警照片', '休眠震动报警视频'];
    if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16, 17, 18, -1, -2].indexOf(type) > -1) {
      photoTypeText = type === -1 ? '全部照片' : type === -2 ? '全部视频' : photoTypeAll[type];
      return photoTypeText
    } else if (type === 99) {
      return '停车数据上传中'
    } else {
      return '其他'
    }
  },
  // 数据格式
  numberFormat (value, digit = 2) {
    value = parseFloat(value);
    if (value < 10000) {
      return value.toFixed(digit);
    } else {
      let sizes = ['', '万', '亿', '万亿'];
      let i = Math.floor(Math.log(value) / Math.log(10000));
      return ((value / Math.pow(10000, i))).toFixed(digit) + sizes[i];
    }
  },
  flowFormat (value) {
    value = parseFloat(value);
    if (value < 1073741824) {
      return (value / 1048576).toFixed(1) + 'M';
    } else {
      return (value / 1073741824).toFixed(1) + 'G';
    }
  },
  // 地址解析
  // 方法一(暂时弃用)
  // transform.pointToAddress(AMap, 104.065755, 30.657555, 1, function (res) {})
  // 方法二
  // transform.pointToAddress(104.065755, 30.657555, 1, function (res) {})
  // use
  // ShowMedia,PhotoList,PositionServer
  // 回调方法
  pointToAddress (lon, lat, type, callBack) {
    // 逆地理编码
    const token = document.cookie.split(";").map(item=>item.split("=")).find(item=>item[0].trim()==='tk');
    axios.post('/v3/u/geocode/regeo', {lon,lat, token:token[1] }).then((response)=>{
      callBack({code:0,address:response.data.data.address})
    })


    // // 加载地理编码插件
    // AMap.plugin(['AMap.Geocoder'], function () {
    //   let MGeocoder = new AMap.Geocoder({
    //     radius: 1000,
    //     extensions: 'all'
    //   });
    //   // 返回地理编码结果
    //   // 每次都解析数组的第一组坐标点
    //   MGeocoder.getAddress([lon, lat], function (status, result) {
    //     // console.log(result);
    //     // result可能为空对象
    //     let showAddress = '';
    //     if (status === 'complete' && result.info === 'OK') {
    //       let addressInfo = result.regeocode.addressComponent;
    //       if (type === 1) {
    //         // 地图自动生成的详细地址
    //         showAddress = result.regeocode.formattedAddress;
    //       } else if (type === 2) {
    //         // 普通的省市区街道等
    //         showAddress = addressInfo.province + addressInfo.city + addressInfo.district + addressInfo.township + addressInfo.street + addressInfo.streetNumber;
    //       } else if (type === 3) {
    //         // 普通的省市区街道 + 附近的建筑名称
    //         let buildingName = addressInfo.building ? '(' + addressInfo.building + ')' : '';
    //         showAddress = addressInfo.province + addressInfo.city + addressInfo.district + addressInfo.township + addressInfo.street + addressInfo.streetNumber + buildingName;
    //       } else if (type === 4) {
    //         // 只要建筑名称
    //         showAddress = addressInfo.building ? addressInfo.building : '';
    //       } else if (type === 5) {
    //         // 只要省市区
    //         showAddress = addressInfo.province + addressInfo.city + addressInfo.district
    //       } else if (type === 6) {
    //         // 只要省市
    //         showAddress = addressInfo.province + addressInfo.city
    //       } else {
    //         showAddress = result.regeocode.formattedAddress;
    //       }
    //       callBack({code: 0, address: showAddress});
    //     } else {
    //       callBack({code: 1, address: showAddress, msg: '地址无法解析'});
    //     }
    //   })
    // });
  },
  regeoAddress (_id, type, callBack) {
    // 逆地理编码
    axios.post('/v3/u/resGeGeo', {_id,type }).then((response)=>{

      callBack({code:0,address:response.data.data.location})
    })
  },
  // 异步方法
  pointToAddress2 (lon, lat, type) {
    return new Promise((resolve, reject)=>{
      // 逆地理编码
      // 加载地理编码插件
      AMap.plugin(['AMap.Geocoder'], function () {
        let MGeocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: 'all'
        });
        // 返回地理编码结果
        // 每次都解析数组的第一组坐标点
        MGeocoder.getAddress([lon, lat], function (status, result) {
          // console.log(result);
          // result可能为空对象
          let showAddress = '';
          if (status === 'complete' && result.info === 'OK') {
            let addressInfo = result.regeocode.addressComponent;
            if (type === 1) {
              // 地图自动生成的详细地址
              showAddress = result.regeocode.formattedAddress;
            } else if (type === 2) {
              // 普通的省市区街道等
              showAddress = addressInfo.province + addressInfo.city + addressInfo.district + addressInfo.township + addressInfo.street + addressInfo.streetNumber;
            } else if (type === 3) {
              // 普通的省市区街道 + 附近的建筑名称
              let buildingName = addressInfo.building ? '(' + addressInfo.building + ')' : '';
              showAddress = addressInfo.province + addressInfo.city + addressInfo.district + addressInfo.township + addressInfo.street + addressInfo.streetNumber + buildingName;
            } else if (type === 4) {
              // 只要建筑名称
              showAddress = addressInfo.building ? addressInfo.building : '';
            } else if (type === 5) {
              // 只要省市区
              showAddress = addressInfo.province + addressInfo.city + addressInfo.district
            } else if (type === 6) {
              // 只要省市
              showAddress = addressInfo.province + addressInfo.city
            } else {
              showAddress = result.regeocode.formattedAddress;
            }
            resolve({code: 0, address: showAddress});
          } else {
            resolve({code: 1, address: showAddress, msg: '地址无法解析'});
          }
        })
      });
    });
  },
};

export {
  getTime,
  formCheck,
  checkBrowser,
  transform,
  stringFn
};
